/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IMultiwrap, IMultiwrapInterface } from "../IMultiwrap";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newRoyaltyRecipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newRoyaltyBps",
        type: "uint256",
      },
    ],
    name: "DefaultRoyalty",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnerUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "royaltyRecipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "royaltyBps",
        type: "uint256",
      },
    ],
    name: "RoyaltyForToken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "wrapper",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sentTo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenIdOfShares",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sharesUnwrapped",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "erc1155AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[][]",
            name: "erc1155TokensToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "uint256[][]",
            name: "erc1155AmountsToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "address[]",
            name: "erc721AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[][]",
            name: "erc721TokensToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "address[]",
            name: "erc20AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "erc20AmountsToWrap",
            type: "uint256[]",
          },
        ],
        indexed: false,
        internalType: "struct MultiTokenTransferLib.MultiToken",
        name: "wrappedContents",
        type: "tuple",
      },
    ],
    name: "TokensUnwrapped",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "wrapper",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenIdOfShares",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "erc1155AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[][]",
            name: "erc1155TokensToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "uint256[][]",
            name: "erc1155AmountsToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "address[]",
            name: "erc721AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[][]",
            name: "erc721TokensToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "address[]",
            name: "erc20AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "erc20AmountsToWrap",
            type: "uint256[]",
          },
        ],
        indexed: false,
        internalType: "struct MultiTokenTransferLib.MultiToken",
        name: "wrappedContents",
        type: "tuple",
      },
    ],
    name: "TokensWrapped",
    type: "event",
  },
  {
    inputs: [],
    name: "contractType",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractVersion",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getDefaultRoyaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getRoyaltyInfoForToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_royaltyRecipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_royaltyBps",
        type: "uint256",
      },
    ],
    name: "setDefaultRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "bps",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfoForToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amountToRedeem",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_sendTo",
        type: "address",
      },
    ],
    name: "unwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "erc1155AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[][]",
            name: "erc1155TokensToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "uint256[][]",
            name: "erc1155AmountsToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "address[]",
            name: "erc721AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[][]",
            name: "erc721TokensToWrap",
            type: "uint256[][]",
          },
          {
            internalType: "address[]",
            name: "erc20AssetContracts",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "erc20AmountsToWrap",
            type: "uint256[]",
          },
        ],
        internalType: "struct MultiTokenTransferLib.MultiToken",
        name: "wrappedContents",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "uriForShares",
        type: "string",
      },
    ],
    name: "wrap",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
];

export class IMultiwrap__factory {
  static readonly abi = _abi;
  static createInterface(): IMultiwrapInterface {
    return new utils.Interface(_abi) as IMultiwrapInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IMultiwrap {
    return new Contract(address, _abi, signerOrProvider) as IMultiwrap;
  }
}
